import React from "react";

import { Grid } from "affinityUI/elements/grid";
import { Field, FieldLabel, ValidationError } from "affinityUI/form/components";
import { Checkbox } from "affinityUI/form/inputs/checkbox";

import { useAffinityField } from "../../helpers";

import { CheckboxOption } from "./components/checkboxOption";

export const CheckboxGroupField: React.FC<
  Omit<React.ComponentProps<typeof Checkbox>, "name"> & { name: string; options: Array<{ id: string; label: string }> }
> = ({ children, name, options }) => {
  const [, { error }] = useAffinityField(name);
  const groupId = `field-${name}`;

  return (
    <Field role="group" id={name} aria-labelledby={groupId}>
      <FieldLabel id={groupId}>{children}</FieldLabel>
      <Grid $tight>
        {error && <ValidationError>{error}</ValidationError>}
        {options.map(({ id, label }) => (
          <CheckboxOption key={id} value={id} name={name}>
            {label}
          </CheckboxOption>
        ))}
      </Grid>
    </Field>
  );
};
